<div
  *ngIf="breadcrumbs$ | async as breadcrumbs; else title"
  data-test-id="route-breadcrumbs"
  class="py-4 heading-container"
>
  <app-breadcrumb-navigation
    [link]="breadcrumbs.link"
    [dataTestId]="dataTestId"
    [pageToNavigateTitle]="breadcrumbs.previousPageTitle"
    [pageTitle]="breadcrumbs.pageTitle"
    [titleDataTestId]="breadcrumbs.testId"
  ></app-breadcrumb-navigation>
</div>

<ng-template #title>
  <div data-test-id="route-title" class="py-4 heading-container">
    <div *ngIf="iconRef" class="d-inline-block align-middle me-2">
      <svg-icon src="{{ iconRef }}" class="icon-route-title"></svg-icon>
    </div>

    <h1 class="d-inline-block align-middle m-0" data-test-id="route-title-value">{{ defaultTitle | translate }}</h1>
  </div>
</ng-template>
